export default __webpack_public_path__ + "static/big-image1-d35970a3e72d95f44b229acb87689455.svg";